import { render, staticRenderFns } from "./EmptyInspectionsTile.vue?vue&type=template&id=0c2b8bd4&scoped=true"
import script from "./EmptyInspectionsTile.vue?vue&type=script&lang=ts"
export * from "./EmptyInspectionsTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b8bd4",
  null
  
)

export default component.exports